import { EMPTY_STRING } from 'constants/general';
import { t } from 'services/i18n.service';
import { removeEmojis } from 'utils/routine-suggestion.util';

// Per-habit controls repeat for every row, so screen readers need the habit in
// each control's name to tell "Delete" on one row from "Delete" on the next.
// Emojis are dropped because VoiceOver reads them aloud by their long names.
export const getHabitAccessibleName = (name?: string): string => {
  const spokenName = removeEmojis(name ?? EMPTY_STRING);
  return spokenName.length > 0
    ? spokenName
    : t('routine_suggestion.untitled_habit');
};
